import { CreateSMSInterface } from "../interfaces/SMSInterfaces/CreateSMSInterface";
import { SMSInterface } from "../interfaces/SMSInterfaces/SMS";
import BaseService from "./BaseService";

export class SMSService extends BaseService<SMSInterface, CreateSMSInterface>{ 
    constructor(){
        let url: string = '/sms/admin'
        super(url)
    }
}